import React from 'react';
import {makeStyles, withStyles} from '@material-ui/core/styles';

//material-ui core
import {Card, CardContent, Divider, FormControl, Grid, Input, InputLabel, TextField, Typography} from '@material-ui/core';
import {Line} from 'react-chartjs-2';
import numeral from 'numeral';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  input: {
    color: '#4759a1',
  },
}));
const CssTextField = withStyles({
  root: {
    '& label.MuiInputLabel-outlined': {
      color: '#4759a1',
    },
    '& label.Mui-focused': {
      color: '#4759a1',
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#4759a1',
        color: '#4759a1',
      },
      '&:hover fieldset': {
        borderColor: '#4759a1',
        color: '#4759a1',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#4759a1',
        color: '#4759a1',
      },
      '&.Mui-disabled fieldset': {
        borderColor: '#4759a1',
        color: '#4759a1',
      },
    },
  },
})(TextField);

const MonografiKelurahan = (props) => {
  const classes = useStyles();
  const {detailMonografiKelurahan, setDetailMonografiKelurahan, chartMonografiKelurahan, setChartMonografiKelurahan} = props;

  // console.log('detailMonografiKelurahan :', detailMonografiKelurahan);
  // console.log('chartMonografiKelurahan :', chartMonografiKelurahan);

  //PROFIL REALISASI VS PIUTANG VS TOTAL PENETAPAN
  const dataOne = {
    labels: chartMonografiKelurahan.map((o) => o.thn_pajak_sppt),
    lineTension: 1,
    datasets: [
      {
        label: 'Realisasi',
        lineTension: 0.5,
        fill: false,
        borderColor: 'rgb(1,180,112)',
        data: chartMonografiKelurahan.map((o) => o.realisasi),
      },
      {
        label: 'Piutang',
        lineTension: 0.5,
        fill: false,
        borderColor: 'rgba(255, 99, 132, 1)',
        data: chartMonografiKelurahan.map((o) => o.tunggakan),
      },
      {
        label: 'Total Penetapan',
        lineTension: 0.5,
        fill: false,
        borderColor: 'rgb(255,194,0)',
        data: chartMonografiKelurahan.map((o) => o.ketetapan),
      },
    ],
  };

  let optionsOne = {
    responsive: true,
    plugins: {
      legend: {
        display: true,
        position: 'bottom',
      },
    },
  };

  //PROFIL PERTUMBUHAN JUMLAH OBJEK PAJAK
  const dataTwo = {
    labels: chartMonografiKelurahan.map((o) => o.thn_pajak_sppt),
    // lineTension: 1,
    datasets: [
      {
        label: 'Jumlah SPPT',
        lineTension: 0.2,
        fill: true,
        backgroundColor: 'rgba(55,181,255,0.44)',
        borderColor: 'rgba(54, 162, 235, 1)',
        data: chartMonografiKelurahan.map((o) => o.total_sppt),
      },
    ],
  };

  let optionsTwo = {
    responsive: true,
    plugins: {
      legend: {
        display: true,
        position: 'bottom',
      },
    },
  };

  return (
    <div className={classes.root}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={3} style={{backgroundColor: '#4759a1'}}>
          <Typography align={'left'} variant={'h6'} style={{color: '#f8e354'}}>
            {detailMonografiKelurahan.nm_kelurahan}
          </Typography>
        </Grid>
        <Grid item xs={12} md={9} style={{fontWeight: 'bold', color: '#4759a1', backgroundColor: '#c9c9cb'}}>
          <Typography align={'right'}>MONOGRAPHY FISCAL</Typography>
        </Grid>
      </Grid>
      <Grid container spacing={2} style={{marginTop: 20}}>
        <Grid item xs={12} md={3}>
          <Card style={{backgroundColor: '#4759a1', height: 200, marginBottom: 20}}>
            <CardContent>
              <Typography align={'left'} variant={'subtitle2'} style={{color: 'white'}}>
                LUAS WILAYAH
              </Typography>
              <Typography align={'left'} style={{color: '#f8e354'}}>
                {numeral(detailMonografiKelurahan.luas_wilayah).format('0,0')} m2
              </Typography>
            </CardContent>
          </Card>
          <CssTextField
            label="Lurah"
            name="nm_lurah"
            type="text"
            value={detailMonografiKelurahan.nm_lurah}
            variant="outlined"
            InputLabelProps={{
              shrink: true,
            }}
            inputProps={{className: classes.input}}
            disabled
          />
          <div style={{marginTop: 15}}>
            <CssTextField
              label="Jumlah Penduduk"
              id="outlined-basic"
              name="jml_penduduk"
              type="text"
              value={numeral(detailMonografiKelurahan.jml_penduduk).format('0,0')}
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
              inputProps={{className: classes.input}}
              disabled
            />
          </div>
          <div style={{marginTop: 15}}>
            <CssTextField
              disabled
              label="Jumlah Wajib Pajak"
              id="outlined-basic"
              name="jml_wp"
              type="text"
              value={numeral(detailMonografiKelurahan.jml_wp).format('0,0')}
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
              inputProps={{className: classes.input}}
            />
          </div>
          <div style={{marginTop: 15}}>
            <CssTextField
              disabled
              label="Jumlah Objek Pajak"
              id="outlined-basic"
              name="jml_op"
              type="text"
              value={numeral(detailMonografiKelurahan.jml_op).format('0,0')}
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
              inputProps={{className: classes.input}}
            />
          </div>
          <div style={{marginTop: 15}}>
            <CssTextField
              disabled
              label="Total Luas Bumi SPPT"
              id="outlined-basic"
              name="total_luas_bumi_sppt"
              type="text"
              value={numeral(detailMonografiKelurahan.total_luas_bumi_sppt).format('0,0')}
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
              inputProps={{className: classes.input}}
            />
          </div>
          <div style={{marginTop: 15}}>
            <CssTextField
              disabled
              label="Total Luas Bangunan SPPT"
              id="outlined-basic"
              name="total_luas_bng_sppt"
              type="text"
              value={numeral(detailMonografiKelurahan.total_luas_bng_sppt).format('0,0')}
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
              inputProps={{className: classes.input}}
            />
          </div>
        </Grid>
        <Grid item xs={12} md={9}>
          <Card>
            <CardContent>
              <Typography variant="subtitle1" style={{textAlign: 'center'}}>
                Profil Realisasi Piutang & Total Penetapan
              </Typography>
              <Line data={dataOne} options={optionsOne} />
            </CardContent>
          </Card>
          <Card style={{marginTop: 15}}>
            <CardContent>
              <Typography variant="subtitle1" style={{textAlign: 'center'}}>
                Profil Pertumbuhan Jumlah SPPT
              </Typography>
              <Line data={dataTwo} options={optionsTwo} />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </div>
  );
};

export default MonografiKelurahan;
